export const EM_DASH = "—";
